'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { useLenis } from 'lenis/react';
import { createContext, useContext, useState } from 'react';
import { Button } from '~/components/button';
import { Image } from '~/components/image';
import { removeItem, updateItemQuantity } from '../actions';
import { useCartContext } from '../cart-context';
import s from './modal.module.css';
const ModalContext = createContext();
export function useCartModal() {
  return useContext(ModalContext);
}
export function CartModal(t0) {
  const $ = _c(25);
  const {
    children
  } = t0;
  const lenis = useLenis();
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== lenis) {
    t1 = () => {
      setIsOpen(true);
      lenis?.stop();
    };
    $[0] = lenis;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openCart = t1;
  let t2;
  if ($[2] !== lenis) {
    t2 = () => {
      setIsOpen(false);
      lenis?.start();
    };
    $[2] = lenis;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeCart = t2;
  let t3;
  if ($[4] !== closeCart || $[5] !== isOpen || $[6] !== openCart) {
    t3 = {
      isOpen,
      openCart,
      closeCart
    };
    $[4] = closeCart;
    $[5] = isOpen;
    $[6] = openCart;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(s.modal, "fixed size-full z-30");
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== closeCart) {
    t5 = e => {
      if (e.key === "Enter" || e.key === " ") {
        closeCart();
      }
    };
    $[9] = closeCart;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== closeCart || $[12] !== t5) {
    t6 = <div className="absolute inset-0" onClick={closeCart} onKeyDown={t5} role="button" tabIndex={0} />;
    $[11] = closeCart;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn(s.inner, "bg-contrast absolute z-30 inset-x-safe top-header-height bottom-safe dt:sbottom-22 spx-8 dt:spx-16 py-safe dt:spy-56 flex flex-col dt:dr-grid dt:grid-rows-[auto_1fr] items-start uppercase");
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== closeCart) {
    t8 = <div className={t7}><InnerCart closeCart={closeCart} /></div>;
    $[15] = closeCart;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isOpen || $[18] !== t6 || $[19] !== t8) {
    t9 = <div className={t4} data-open={isOpen}>{t6}{t8}</div>;
    $[17] = isOpen;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== children || $[22] !== t3 || $[23] !== t9) {
    t10 = <ModalContext.Provider value={t3}>{children}{t9}</ModalContext.Provider>;
    $[21] = children;
    $[22] = t3;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function InnerCart(t0) {
  const $ = _c(18);
  const {
    closeCart
  } = t0;
  const {
    cart
  } = useCartContext();
  const isEmpty = cart?.lines?.length === 0;
  const t1 = isEmpty ? "dt:col-span-10 col-start-2 dt:col-start-3" : "col-span-2 col-start-2 dt:col-start-3";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1, "uppercase flex flex-col sgap-y-24");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isEmpty ? "your cart is empty" : `cart [${cart?.lines?.length}]`;
  let t4;
  if ($[2] !== t3) {
    t4 = <p className="h1">{t3}</p>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== closeCart) {
    t5 = <button type="button" onClick={closeCart} className="link underline decoration-dotted">X close</button>;
    $[4] = closeCart;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== cart?.checkoutUrl || $[11] !== cart?.cost?.subtotalAmount?.amount || $[12] !== cart?.lines || $[13] !== isEmpty) {
    t7 = !isEmpty && <><div className="dt:h-full overflow-y-auto grid grid-cols-2 dt:grid-cols-subgrid sgap-y-40 dt:sgap-y-16 spb-16 smt-16 dt:mt-0 col-span-4 border-t border-white/10" data-lenis-prevent={true}>{cart?.lines?.map(_temp)}</div><div className="w-full dt:col-start-5 dt:col-end-[-1] col-span-4 grid grid-cols-subgrid sgap-y-4 spt-16 dt:spt-40 border-t border-white/10"><div className="dt:col-start-3 col-span-2 flex justify-between p w-full order-1"><p>sub total</p><p>$ {Number(cart?.cost?.subtotalAmount?.amount).toFixed(2)}</p></div><Button className="dt:col-start-3 order-2 col-span-2 bg-secondary text-primary spx-8 spy-7 dt:spy-4 cta" href={cart?.checkoutUrl}><span>checkout</span></Button></div></>;
    $[10] = cart?.checkoutUrl;
    $[11] = cart?.cost?.subtotalAmount?.amount;
    $[12] = cart?.lines;
    $[13] = isEmpty;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp(t0, idx) {
  const {
    id,
    merchandise,
    cost,
    quantity
  } = t0;
  return <div className={cn("grid grid-cols-2 sgap-16 dt:gap-y-0 dt:sgap-x-gap dt:grid-cols-subgrid dt:grid-rows-[auto_1fr] col-span-4 dt:spt-16 border-white/10", idx !== 0 && "border-t")} key={`${idx}-${id}`}><div className="grid place-items-center scan-lines secondary sp-16 aspect-square"><Image src={merchandise.product.featuredImage.url} alt={merchandise.product.title} width={merchandise.product.featuredImage.width} height={merchandise.product.featuredImage.height} /></div><div className="flex flex-col sgap-y-24"><p className="h2">{merchandise?.product?.title}{" "}{merchandise?.selectedOptions?.[0]?.value}</p><p className="p">$ {Number(cost?.totalAmount?.amount).toFixed(2)}</p></div><p className="col-span-2 smb-8 dt:mb-0 p">{merchandise?.product?.description}</p><div className="dt:col-start-3 col-span-2 flex justify-between items-end"><Quantity payload={{
        merchandiseId: merchandise?.id,
        quantity
      }} /><RemoveButton merchandiseId={merchandise?.id} className="link" /></div></div>;
}
const quantityAction = {
  minus: -1,
  plus: 1
};
function Quantity(t0) {
  const $ = _c(13);
  const {
    payload
  } = t0;
  const {
    updateCartItem
  } = useCartContext();
  let t1;
  if ($[0] !== payload || $[1] !== updateCartItem) {
    t1 = async function formAction(type) {
      const updatePayload = {
        ...payload,
        quantity: Math.max(1, payload.quantity + quantityAction[type])
      };
      updateCartItem(payload.merchandiseId, type);
      await updateItemQuantity(null, updatePayload);
    };
    $[0] = payload;
    $[1] = updateCartItem;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formAction = t1;
  let t2;
  if ($[3] !== formAction) {
    t2 = <QuantityButton formAction={() => formAction("minus")} className="ssize-22 grid place-content-center">-</QuantityButton>;
    $[3] = formAction;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== payload.quantity) {
    t3 = <span className="spx-8">{payload.quantity}</span>;
    $[5] = payload.quantity;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== formAction) {
    t4 = <QuantityButton formAction={() => formAction("plus")} className="ssize-22 grid place-content-center ">+</QuantityButton>;
    $[7] = formAction;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex items-center border border-white/10 cta">{t2}{t3}{t4}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function QuantityButton(t0) {
  const $ = _c(6);
  const {
    formAction,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <button type="submit" className="p1 touch-manipulation" aria-label="Remove cart item">{children}</button>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== formAction || $[4] !== t1) {
    t2 = <form action={formAction} className={className}>{t1}</form>;
    $[2] = className;
    $[3] = formAction;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function RemoveButton(t0) {
  const $ = _c(7);
  const {
    merchandiseId,
    className
  } = t0;
  const {
    updateCartItem
  } = useCartContext();
  let t1;
  if ($[0] !== merchandiseId || $[1] !== updateCartItem) {
    t1 = async function formAction() {
      updateCartItem(merchandiseId, "delete");
      await removeItem(null, merchandiseId);
    };
    $[0] = merchandiseId;
    $[1] = updateCartItem;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formAction = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="submit" className="p1 touch-manipulation" aria-label="Remove cart item">remove</button>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== formAction) {
    t3 = <form action={formAction} className={className}>{t2}</form>;
    $[4] = className;
    $[5] = formAction;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}